/**
 * Phase 3d — /unsubscribed landing.
 *
 * Target of the 302 redirect from
 *   GET /api/prospective-employees/unsubscribe?token=…
 *
 * We intentionally show the same content whether the token was valid or
 * not — this avoids leaking which email addresses have active
 * subscriptions. The backend flips `unsubscribed_at` for valid tokens
 * silently; invalid tokens fall through with no DB change.
 */
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { track } from "@/lib/analytics";

export default function Unsubscribed() {
    const { t } = useTranslation();

    useEffect(() => {
        track("good_stuff_unsubscribed_page_view", {});
    }, []);

    return (
        <main className="unsub-page" data-testid="unsubscribed-page">
            <div className="unsub-eyebrow mono">{t("unsubscribed.eyebrow")}</div>
            <h1 className="unsub-title">{t("unsubscribed.title")}</h1>
            <p className="unsub-body">{t("unsubscribed.body")}</p>
            <p className="unsub-body">{t("unsubscribed.changed_mind")}</p>
            <a href="/" className="unsub-back" data-testid="unsubscribed-back">
                {t("unsubscribed.back")} →
            </a>
        </main>
    );
}
